import React from 'react';
import { useHistory } from 'react-router-dom';
import './BackButton.scss';
import { TranslationUtils } from '../../utils';

interface BackButtonProps {
    path?: string;
}

export const BackButton: React.FC<BackButtonProps> = (props: BackButtonProps) => {
    const history = useHistory();

    const handleGoBack = () => {
        if (props && props.path) {
            history.push(props.path);
            return;
        }

        history.goBack();
    };

    return (
        <div className="link-back no-print">
            <button id="link-navigation-back" type="button" className="btn btn-link" onClick={handleGoBack}>{`< ${TranslationUtils.get(
                'back'
            )}`}</button>
        </div>
    );
};
